import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function ShareableReportsFeatureGate(props: Props) {
    const {isOpen, onClose} = props;

    return (
        <FeatureGateModalWrapper
            title='Share reports easily'
            description='Tailor your reports to highlight key insights and unlock the ability to share them with your team.'
            bullets={[
                'Customize your reports to show what matters most to you.',
                'Share them with individuals or your whole team for easy access.',
                'Spark discussions and support informed decision-making with shared insights.',
            ]}
            feature='sharableListsReports'
            isOpen={isOpen}
            onClose={onClose}
        />
    );
}
